import { render, staticRenderFns } from "./togglepage.vue?vue&type=template&id=265a4b3c"
import script from "./togglepage.vue?vue&type=script&lang=js"
export * from "./togglepage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports